export const colors = {
  color_keppel: '#38b2a6',
};
